// extracted by mini-css-extract-plugin
module.exports = {"root":"EditShuttleAmenitiesPanel_root__VrmKi","form":"EditShuttleAmenitiesPanel_form__3DbHu","title":"EditShuttleAmenitiesPanel_title__391_3"};